import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {AbstractProdForm, ProdFormField, ProdFormFieldType} from 'prod-form';
import {OrganizationService} from "../../../services/organization.service";
import {SelectedRecords} from 'prod-grid';
import {OrganizationTreeSelect} from "../../../dip/organization-tree-select";
import {TimezoneService} from "../../../services/timezone-service";
import {RoleService} from "../../../services/role.service";
import {Role} from "../../../dip/role";
import {HttpFilterParam} from 'prod-shared';
import {DistributorService} from "../../../services/distributor.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-company-detail',
  templateUrl: './company-detail.component.html'
})
export class CompanyDetailComponent extends AbstractProdForm implements OnInit {
  @Input() isSite: boolean = false;
  private isFieldsEditable: boolean = this.roleService.hasRole([Role.ROLE_COMPANY_EDIT]);
  private isSystem: boolean = this.roleService.hasRole([Role.ROLE_SYS]);
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'name',
      label: this.translate.instant('company.details.name'),
      type: ProdFormFieldType.TEXT,
      isEditable: this.isSystem
    }),
    ProdFormField.create({
      name: 'description',
      label: this.translate.instant('company.details.description'),
      type: ProdFormFieldType.TEXTAREA,
      isEditable: this.isFieldsEditable
    }),
    ProdFormField.create({
      name: this.isSystem ? 'distributor' : 'distributor_name',
      label: this.translate.instant('company.details.distributor'),
      type: this.isSystem ? ProdFormFieldType.SELECT : ProdFormFieldType.TEXT,
      selectParameters: {
        selectDataService: DistributorService,
        filter: new HttpFilterParam({
          property: 'organizationType',
          operator: 'eq',
          value: 3
        }),
        isMulti: false,
        isNarrowDown: true,
        isComplete: true
      },
      isEditable: this.isSystem
    }),
    ProdFormField.create({
      name: 'timezone',
      label: this.translate.instant('company.details.timezone'),
      type: ProdFormFieldType.SELECT,
      selectParameters: {
        selectDataService: TimezoneService,
        isMulti: false,
        isNarrowDown: true,
        isComplete: true
      },
      isEditable: this.isFieldsEditable
    })
  ];
  records: SelectedRecords = new SelectedRecords();
  initializeFormEvent$: EventEmitter<void> = new EventEmitter<void>();
  style = {inputWidth: '260px', labelWidth: '120px'};

  constructor(override dataService: OrganizationService,
              private organizationTreeSelect: OrganizationTreeSelect,
              private roleService: RoleService,
              private translate: TranslateService) {
    super();
    organizationTreeSelect.formComponents.push(this);
  }

  ngOnInit(): void {
    if (this.isSite) {
      this.fields.forEach(field => {
        if (['distributor', 'distributor_name'].indexOf(field.name) !== -1) {
          field.type = ProdFormFieldType.HIDDEN;
          field.submitValue = false;
        }
      })
      this.fields.push(
        ProdFormField.create({
          name: 'applicationKey',
          label: this.translate.instant('company.details.application_key'),
          type: ProdFormFieldType.TEXT,
          isEditable: false,
          disabledOnAdd: true
        }),
        ProdFormField.create({
          name: 'networkKey',
          label: this.translate.instant('company.details.network_key'),
          type: ProdFormFieldType.TEXT,
          isEditable: false,
          disabledOnAdd: true
        }),
      );
    }
    this.records.toggle(!this.isSite ? this.organizationTreeSelect.company : this.organizationTreeSelect.site);
    this.data.records = this.records;
    this.data.formResponseEvent = new EventEmitter();

    this.data.formResponseEvent.subscribe(() => {
      this.organizationTreeSelect.organizationTreeUpdate$.emit();
    });
  }

  ngOnDestroy() {
    this.organizationTreeSelect.removeFormComponent(this);
  }
}
